import React, {useState, forwardRef} from 'react'
import {Form, Radio} from 'antd'
import uniqBy from 'lodash.uniqby'
import Heading from 'components/shared/Heading'
import BrokerSearch from './BrokerSearch'

const BrokerRadioControls = forwardRef(({contactPerson, onChange, canOrderForOthers, possibleContactPersons = []}, ref) => {
  const initialShowOtherState = !(possibleContactPersons.map(({id}) => (id)).includes(contactPerson.id))
  const defaultValue = initialShowOtherState ? 'other' : contactPerson.id
  const [showOther, setShowOther] = useState(initialShowOtherState)
  const handleRadioSelect = (e) => {
    if (e.target.value === 'other') {
      setShowOther(true)
      onChange(null)
    } else {
      setShowOther(false)
      onChange(e.target.value)
    }
  }

  return (
    <Radio.Group defaultValue={defaultValue} onChange={handleRadioSelect} ref={ref} name="brokers">
      {possibleContactPersons.map((broker) => (
        <Radio key={broker.id} value={broker.id}>{broker.name} ({broker.customer.name})</Radio>
      ))}
      {canOrderForOthers && (
        <Radio key="other" value="other">
          Annen
          {showOther && (
            <BrokerSearch initalValue={initialShowOtherState ? contactPerson : null} onChange={onChange} />
          )}
        </Radio>
      )}
    </Radio.Group>
  )
})

function FieldWrapper({viewer, children}) {
  return(
    <div className="broker-info-field">
      <Heading level={3}>Megler</Heading>
      <p>
        Du er logget inn som {viewer.name} ({viewer.broker.email}).
        Under kan velg den som skal stå som megler på dette oppdraget.
      </p>
      <p>
        Den du velger vil være kontaktperson og vil motta mail med oppdragsinformasjon.
      </p>
      {children}
    </div>
  )
}

export default function BrokerPicker ({form, viewer, contactPerson, possibleContactPersons}) {
  // More than 1 person is listed as a possible contact person for this webOrder
  if (possibleContactPersons.length > 1 || viewer.broker.linkedAccounts.length) {
    return (
      <FieldWrapper viewer={viewer}>
        <Form.Item name="brokerId">
          <BrokerRadioControls
            contactPerson={contactPerson || viewer.broker}
            canOrderForOthers={viewer.canOrderForOthers}
            possibleContactPersons={uniqBy([viewer.broker, ...viewer.broker.linkedAccounts, ...possibleContactPersons], 'id')}
          />
        </Form.Item>
      </FieldWrapper>
    )
  } else if (viewer.canOrderForOthers) {
    // Has the operator role so show broker search
    return (
      <FieldWrapper viewer={viewer}>
        <Form.Item name="brokerId">
          <BrokerSearch initalValue={contactPerson} />
        </Form.Item>
      </FieldWrapper>
    )
  }

  // contact person cannot be changed
  return null
}
